import { useMemo } from "react";
import { motion } from "framer-motion";

const COLORS = ["#ff648b", "#ed4a76", "#ffd166", "#7bd389", "#5bc0eb", "#c77dff", "#ffffff"];

export const ConfettiBurst = ({ count = 20 }) => {
  const bits = useMemo(
    () =>
      Array.from({ length: count }).map((_, i) => {
        const angle = Math.random() * Math.PI * 2;
        const dist = 90 + Math.random() * 180;
        return {
          id: i,
          x: Math.cos(angle) * dist,
          y: Math.sin(angle) * dist - 20,
          rot: Math.random() * 540 - 270,
          color: COLORS[Math.floor(Math.random() * COLORS.length)],
          size: 7 + Math.random() * 10,
          round: Math.random() > 0.5,
          delay: Math.random() * 0.08,
          dur: 0.7 + Math.random() * 0.5,
        };
      }),
    [count]
  );

  return (
    <div className="pointer-events-none absolute inset-0 z-0 flex items-center justify-center">
      {[0, 1, 2].map((i) => (
        <motion.span
          key={"ring" + i}
          initial={{ scale: 0.2, opacity: 0.5 }}
          animate={{ scale: 2.6, opacity: 0 }}
          transition={{ duration: 0.85, delay: i * 0.12, ease: "easeOut" }}
          className="absolute w-44 h-44 rounded-full border-[5px]"
          style={{ borderColor: COLORS[i % COLORS.length] }}
        />
      ))}
      {bits.map((b) => (
        <motion.span
          key={b.id}
          initial={{ x: 0, y: 0, opacity: 1, scale: 1, rotate: 0 }}
          animate={{ x: b.x, y: b.y, opacity: 0, scale: 0.5, rotate: b.rot }}
          transition={{ duration: b.dur, delay: b.delay, ease: "easeOut" }}
          className="absolute"
          style={{
            width: b.size,
            height: b.size,
            background: b.color,
            borderRadius: b.round ? "9999px" : "2px",
          }}
        />
      ))}
    </div>
  );
};
